module.exports = __webpack_public_path__ + "img/36.205b8af1.jpg";